import _ from 'lodash'
import { FETCH_CARRIERS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CARRIERS:
      return action.payload
    default:
      return state
  }
}
